import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import {
  setFormItemInferenceFetcher,
  setVariableTextEditor,
} from '@super/node-graph-ui'
import { router } from './router'
import { DocumentHeadManager } from '@/components/common/DocumentHeadManager'
import { formNodeApiClient } from '@/lib/api'
import { AdminVariableTextEditor } from '@/features/node-agents/variable-text-editor-adapter'
import '@workos-inc/widgets/styles.css'
import '@/styles/global.css'
import '@radix-ui/themes/styles.css'

// Form Node authoring: inference calls flow through the admin's auth-aware
// API client. Registered before mount so the FlowEditor sees a live fetcher
// from the first render.
setFormItemInferenceFetcher(request => formNodeApiClient.inferItem(request))

// Form Node authoring: the item text editor renders through the admin's
// variable autocomplete so `{{` opens the shared variable picker.
setVariableTextEditor(AdminVariableTextEditor)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <DocumentHeadManager />
    <RouterProvider router={router} />
  </>,
)
